import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationManager from 'react-notifications/lib/NotificationManager';

import Modal from '../../UI/Modal';
import Textarea from '../../UI/Textarea';
import IconMessage from '../../UI/Icons/IconMessage';

import messageActions from '../../../store/actions/messageActions';
import helpers from '../../../helpers/helpers';

const ModalSendMessage = ({ productId, token }) => {
  const dispatch = useDispatch();
  const { messageStatus, messageLoading } = useSelector((state) => state.message);
  const [message_, setMessage] = useState(null);

  const { getTranslationText } = helpers;

  const handleSendMessage = () => {
    if (token && message_) {
      const params = {
        product_id: productId,
        messages: message_,
        photos: [],
      };
      dispatch(messageActions.sendMessage(params, token));
      setMessage(null);
    } else {
      NotificationManager.error(message_ ? 'Please, authorise to send a message' : 'Please, write something');
    }
  };

  const messageChangeHandler = (e) => {
    setMessage(e.target.value);
  };

  return (
    <Modal
      className="product__modal-send-message"
      modalTitle="Send message"
      modalTrigger={(
        <div className="product__data__controls__line">
          <span><IconMessage color="#636171" /></span>
          <p>{getTranslationText('product.send_message')}</p>
        </div>
      )}
      onSubmitLabel="Send"
      onSubmit={handleSendMessage}
      sendSuccess={messageStatus}
      buttonDisabled={messageLoading}
    >
      <Textarea label="Message" name="message" onChange={messageChangeHandler} />
    </Modal>
  );
};

export default ModalSendMessage;
